(() => {
  const fix = (root) => {
    const scope = root || document;
    const images = [...(scope.matches?.('.jdgm-video-card img[alt]') ? [scope] : []), ...scope.querySelectorAll('.jdgm-video-card img[alt]')];
    images.forEach((img) => {
      if ((img.getAttribute('alt') || '').trim().toLowerCase() === 'video thumbnail') img.alt = '';
    });
  };
  fix(document);
  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
    if (node.nodeType === 1) fix(node);
  }))).observe(document.documentElement, { childList: true, subtree: true });
})();
